import React, { useState } from "react";
import { useMyBrokerage } from "@/hooks/useBrokerageManage";
import SupportTicketModal from "@/components/SupportTicket/SupportTicketModal";
import "./MyBrokerageRow.scss";
import AppLink from "@/components/AppLink";

const nameOf = (person) => [person?.firstName, person?.lastName].filter(Boolean).join(" ");

export const UNMANAGED_LINE = "Nobody manages this page yet.";

export const setupRequest = (brokerage) => ({
  subject: `Set up the ${brokerage?.name || "brokerage"} page`,
  description: `Nobody manages the ${brokerage?.name || "brokerage"} page yet. Please help my broker set it up.`,
});

export const managedByLine = (managers) => {
  const people = [...(managers || [])]
    .filter((person) => nameOf(person))
    .sort((a, b) => (a.role === "broker" ? 0 : 1) - (b.role === "broker" ? 0 : 1));
  if (!people.length) return UNMANAGED_LINE;
  const [first, second] = people;
  const lead = first.role === "broker" ? `${nameOf(first)}, your broker` : nameOf(first);
  if (people.length === 1) return `Managed by ${lead}`;
  if (people.length === 2) return `Managed by ${lead}${first.role === "broker" ? "," : ""} and ${nameOf(second)}`;
  return `Managed by ${lead}${first.role === "broker" ? "," : ""} and others in your office`;
};

export const pageHref = (brokerage) => {
  if (brokerage?.pagePath) return brokerage.pagePath;
  const params = new URLSearchParams({ b: brokerage.name });
  if (brokerage.network) params.set("n", brokerage.network);
  return `/agents?${params.toString()}`;
};

const MyBrokerageRow = ({ enabled = true }) => {
  const query = useMyBrokerage(enabled);
  const [asking, setAsking] = useState(false);
  const data = query.data;
  if (!data?.brokerage?.name || data.canManage) return null;
  const line = managedByLine(data.managers);
  const unmanaged = line === UNMANAGED_LINE;
  return (
    <section className="my-brokerage" aria-labelledby="my-brokerage-title">
      <div className="my-brokerage__text">
        <h3 id="my-brokerage-title">Your brokerage page</h3>
        <p className="my-brokerage__name">{data.brokerage.name}</p>
        <p className="my-brokerage__who">
          {line}
          {unmanaged ? (
            <>
              {" "}
              <button type="button" className="my-brokerage__ask" onClick={() => setAsking(true)}>
                Ask us to set it up for your&nbsp;broker.
              </button>
            </>
          ) : null}
        </p>
      </div>
      <AppLink className="my-brokerage__link" href={pageHref(data.brokerage)}>
        View page
      </AppLink>
      {unmanaged ? (
        <SupportTicketModal
          show={asking}
          onHide={() => setAsking(false)}
          initialTicket={asking ? setupRequest(data.brokerage) : null}
        />
      ) : null}
    </section>
  );
};

export default MyBrokerageRow;
